import React from "react";
import { FixedSizeGrid as Grid } from "react-window";
import CatalogProductCard from "./CatalogProductCard";

// Ajuste conforme seu layout
const CARD_WIDTH = 320; // px
const CARD_HEIGHT = 430; // Aumenta a altura para garantir espaço para todo o conteúdo
const GRID_GAP = 16; // px (gap entre os cards)

export default function VirtualizedProductGrid({ produtos, getProductId }) {
  // Calcula colunas responsivas
  const [width, setWidth] = React.useState(window.innerWidth);
  const [maxHeight, setMaxHeight] = React.useState(window.innerHeight);
  React.useEffect(() => {
    const onResize = () => {
      setWidth(window.innerWidth);
      setMaxHeight(window.innerHeight - 250); // 350px é um chute para header/filtros/pagination, ajuste se necessário
    };
    window.addEventListener("resize", onResize);
    onResize();
    return () => window.removeEventListener("resize", onResize);
  }, []);

  let columns = 1;
  if (width >= 1920) columns = 5;
  else if (width >= 1536) columns = 4;
  else if (width >= 1200) columns = 3;
  else if (width >= 900) columns = 2;

  const rows = Math.ceil(produtos.length / columns);
  const gridWidth = Math.min(width, columns * (CARD_WIDTH + GRID_GAP));
  // Altura máxima disponível para o grid
  const neededHeight = rows * (CARD_HEIGHT + GRID_GAP);
  const gridHeight = Math.min(neededHeight, maxHeight);

  return (
    <Grid
    
      columnCount={columns}
      columnWidth={CARD_WIDTH + GRID_GAP}
      height={gridHeight}
      rowCount={rows}
      rowHeight={CARD_HEIGHT + GRID_GAP}
      width={gridWidth}
      style={{ width: "100%", overflowX: "auto" }}
    >
      {({ columnIndex, rowIndex, style }) => {
        const index = rowIndex * columns + columnIndex;
        if (index >= produtos.length) return null;
        const produto = produtos[index];
        return (
          <div
            style={{
              ...style,
              left: style.left + GRID_GAP / 2,
              top: style.top + GRID_GAP / 2,
              width: CARD_WIDTH - GRID_GAP,
              height: CARD_HEIGHT - GRID_GAP,
              padding: 0,
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              rowGap: GRID_GAP,
            }}
          >
            <CatalogProductCard key={getProductId(produto)} produto={produto} style={{ width: '100%' }} />
          </div>
        );
      }}
    </Grid>
  );
}
